// extracted by mini-css-extract-plugin
export var aiStarIcon = "_6z-4";
export var closeButton = "_6z-6";
export var dismissButton = "_6z-3";
export var editImageWithAiContainer = "_6z-8";
export var imageUploadWrapper = "_6z-7";
export var misspelledWord = "_6z-5";
export var spellCheckContainer = "_6z-2";
export var spin = "_6z-1";
export var spinning = "_6z-0";